import { render } from "./TextBoxField.vue?vue&type=template&id=1c04e1e9&scoped=true"
import script from "./TextBoxField.vue?vue&type=script&lang=js"
export * from "./TextBoxField.vue?vue&type=script&lang=js"

import "./TextBoxField.vue?vue&type=style&index=0&id=1c04e1e9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c04e1e9"]])

export default __exports__